<div class="wrapper">
    <fd-checkbox [label]="to.label || key.toString()" [formControl]="formControl"
                 [formlyAttributes]="field"></fd-checkbox>
    @if (!!to.description) {
        <span>
            <app-help-popover [body]="description" [headerTitle]="to.label || key.toString()"
                              [placement]="'bottom'" [enabled]="!field.props.disabled"></app-help-popover>
            <ng-template #description>
                <fd-text [text]="to.description"></fd-text>
            </ng-template>
        </span>
    }
</div>
